import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { DeleteSecretInput_InputAdapter_instanceyylt2nezqm8q as DeleteSecretInput_InputAdapter_instance } from '../type/adapter/DeleteSecretInput_InputAdapter.mjs';
import { obj2vqjd1bjrpmyg as obj } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DeleteSecretMutation_VariablesAdapterClass;
function DeleteSecretMutation_VariablesAdapter() {
  if (DeleteSecretMutation_VariablesAdapterClass === VOID) {
    class $ {
      d6g(writer, value, customScalarAdapters, withDefaultValues) {
        writer.q47('input');
        obj(DeleteSecretInput_InputAdapter_instance).o3z(writer, customScalarAdapters, value.c6g_1);
      }
    }
    initMetadataForObject($, 'DeleteSecretMutation_VariablesAdapter');
    DeleteSecretMutation_VariablesAdapterClass = $;
  }
  return DeleteSecretMutation_VariablesAdapterClass;
}
var DeleteSecretMutation_VariablesAdapter_instance;
function DeleteSecretMutation_VariablesAdapter_getInstance() {
  return DeleteSecretMutation_VariablesAdapter_instance;
}
//region block: init
DeleteSecretMutation_VariablesAdapter_instance = new (DeleteSecretMutation_VariablesAdapter())();
//endregion
//region block: exports
export {
  DeleteSecretMutation_VariablesAdapter_instance as DeleteSecretMutation_VariablesAdapter_instance34s22vv07twdl,
};
//endregion

//# sourceMappingURL=DeleteSecretMutation_VariablesAdapter.mjs.map
